/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import CommonContext from "../../hooks/commonContext";
import {
  Container,
  Button,
  IconButton,
  Dialog,
  Typography,
  Divider,
  DialogContent,
  DialogActions,
  Avatar,
  Switch,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PageTitle from "../../components/pageTitle/PageTitle";
import ThemeTable from "../../components/Table/ThemeTable";
import { Columns } from "./employeeTableColumns";
import { Plus, Search } from "lucide-react";
import EditIcon from "@material-ui/icons/Edit";
import LockIcon from "@material-ui/icons/Lock";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { AspectRatio } from "@mui/icons-material";
import { useEffect } from "react";
import {
  getAllEmployee,
  updateEmployee,
} from "../../services/apiservices/employee";
import { useMediaQuery } from "@mui/material";
import { getAppoinmentByDates } from "../../services/apiservices/appoinments";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import AuthContext from "../../hooks/authContext";
import moment from "moment-timezone";
import styles from "./employee.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/free-regular-svg-icons";
import { packageAccess } from "../../services/helpers";
import { Input } from "../../components/ui/input";
import SingleSelectNew from "../../components/SelectField/SingleSelectNew";

const ConfirmApptDiaogStatus = ({ open, onConfirm, onClose, rowitem }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="d-flex flex-center flex-space-between dark:bg-[#1A1F2C]">
        <Typography variant="body" className="mt-20 dialogCancelTitle dark:bg-[#1A1F2C] dark:text-white">
          Inactive Employee
        </Typography>
        <IconButton
        className="dark:bg-[#1A1F2C]"
          style={{ color: "red", marginLeft: "10px" }}
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </div>
      <Divider className="mt-15" />
      <DialogContent className="mb-10 dark:bg-[#1A1F2C]">
        <span className="dark:text-[#F1F5F9]">
          <strong style={{ fontWeight: "600" }} className="dark:text-[#F1F5F9]">
            {rowitem.firstName} {rowitem.lastName}
          </strong>{" "}
          has appointment scheduled in the future. Are you sure you want to inactivate this employee?
        </span>
      </DialogContent>
      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        <Button
          variant="contained"
          onClick={onConfirm}
          className="ph-35 mr-5"
          style={{
            backgroundColor: "green",
            color: "white",
            borderRadius: "10px",
          }}
        >
          Yes
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          className="ph-35 mr-10"
          style={{
            backgroundColor: "gray",
            color: "white",
            borderRadius: "10px",
          }}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const ConfirmNotApptDiaogStatus = ({ open, onConfirm, onClose, rowitem }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="d-flex flex-center flex-space-between dark:bg-[#1A1F2C] ">
        <Typography variant="body" className="mt-20 dialogCancelTitle dark:text-white">
          Inactive Employee
        </Typography>
        <IconButton
        className="dark:bg-[#1A1F2C]"
          style={{ color: "red", marginLeft: "10px" }}
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </div>
      <Divider className="mt-15" />
      <DialogContent className="mb-10 dark:bg-[#1A1F2C]">
        <span className="dark:text-white">
          You are about to inactivate{" "}
          <strong style={{ fontWeight: "600" }} className="dark:text-[#F1F5F9]">
            {rowitem.firstName} {rowitem.lastName}
          </strong>
          . This is disable all access and the employee will be moved to
          Inactive Status. Are you sure you want to proceed?
        </span>
      </DialogContent>
      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        <Button
          variant="contained"
          onClick={onConfirm}
          className="ph-35 mr-5"
          style={{
            backgroundColor: "green",
            color: "white",
            borderRadius: "10px",
          }}
        >
          Yes
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          className="ph-35 mr-10"
          style={{
            backgroundColor: "gray",
            color: "white",
            borderRadius: "10px",
          }}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

const Employee = (props) => {
  const commonContext = useContext(CommonContext);
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const [allEmployees, setAllEmployees] = React.useState([]);
  const [appointments, setAppointments] = React.useState();
  const [searchTerm, setsearchTerm] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [userDialog, setUserDialog] = React.useState(null);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dialogOpenAppts, setDialogOpenAppts] = React.useState(false);
  const [activeUsers, setActiveUsers] = React.useState();
  const [newRoles, setNewRoles] = React.useState("All");
  const [newStatus, setNewStatus] = React.useState(true);
  const [data, setData] = React.useState({});
  const today = dayjs().startOf("day");
  const [switchStatus, setSwitchStatus] = React.useState(true);
  const companyId =
    auth?.userProfile?.role === "superUser"
      ? null
      : auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

  const StatusList = [
    { label: "All Status", value: "All" },
    { label: "Active", value: true },
    { label: "Inactive", value: !true },
  ];

  const Roles = [
    { label: "All Roles", value: "All" },
    { label: "Admin", value: "Admin" },
    { label: "Support", value: "Support" },
    { label: "Client Team", value: "Client Team" },
  ];
  const pkgId = auth?.userProfile?.prdId;
  const allowedPermissions = packageAccess(pkgId);
  const UsersLimits =
    allowedPermissions?.userLimit + auth?.userProfile?.additionalQuantity;

  const hasRole = (item, role) => {
    if (!item?.role) return false;
    return Array.isArray(item.role) ? item.role.includes(role) : item.role === role;
  };
  
  const fetchEmployeesList = async () => {
    setIsLoading(true);
    const date = moment()
      .tz("America/New_York")
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm:ss");
    try {
      const [appointmentsData, employeesResponse] = await Promise.all([
        getAppoinmentByDates(date, null, companyId),
        new Promise((resolve, reject) => getAllEmployee(resolve, reject)),
      ]);
      setAppointments(appointmentsData?.appointments || []);

      if (employeesResponse?.data) {
        const employees = employeesResponse?.data;
        const data = employees?.filter((item) => hasRole(item, "Employee") && !item.deleted);
        const activeUserdata = employees?.filter((item) => hasRole(item, "Employee") && item.status === true);
        setActiveUsers(activeUserdata || 0);
        const empData = employees?.filter(
          (item) => item.role === "companyUser"
        );

        let filterEmpData = data;
        if (auth?.userProfile?.role !== "superUser") {
          filterEmpData = data?.filter((item) => item.companyId === companyId);
        }

        const companyMap = new Map(
          empData?.map((item) => [
            item.id,
            `${item.companyName}`,
          ])
        );

        const allEmp = filterEmpData?.map((eitem) => ({
          ...eitem,
          userName: `${eitem?.firstName} ${eitem?.lastName}`,
          company: companyMap.get(eitem.companyId) || null,
        }));

        setAllEmployees(allEmp);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployeesList();
  }, []);

  const redirectToCreateEmp = (employeeId) => {
    if (typeof employeeId !== "undefined" && employeeId !== "")
      navigate("/peoples/createEmp/" + employeeId);
    else navigate("/peoples/createEmp");
  };

  const redirectToManageGroups = () => {
      navigate("/peoples/manageGroups");
  };

  const loginWithEmployee = (empDetails) => {
    navigate("/ViewEmployeeApp/" + empDetails?.id);
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "userName":
        return (
          <div className={styles.empNameWrapper}>
            <Avatar className={styles.avatarFallback}>
              {rcellItem?.userName?.charAt(0)}
            </Avatar>
            <div>
              <div className="d-flex flex-center">
                <span className={styles.empName}>{rcellItem?.userName}</span>
              </div>
            </div>
          </div>
        );
      case "employeerole":
        return (
          <div
            className={
              rcellItem?.employeerole === "Client Team"
                ? styles.client
                : rcellItem?.employeerole === "Admin"
                ? styles.admin
                : !rcellItem?.employeerole ? styles.unknown
                : styles.support
            }
          >
            {rcellItem?.employeerole ? rcellItem?.employeerole : "Unknown"}
          </div>
        );
      case "email":
        return (
          <>
            <a
              href={`https://mail.google.com/mail/?view=cm&fs=1&to=${
                rcellItem[hcellItem?.id]
              }`}
              rel="noopener noreferrer"
              target="_blank"
              className="resLinks"
              style={{ overflowWrap: "anywhere" }}
            >
              {rcellItem[hcellItem?.id]}
            </a>
          </>
        );
      case "action":
        return (
          <>
            {rcellItem?.role === "Employee" ? (
              <IconButton
                aria-label="Login"
                color="primary"
                size="small"
                onClick={() => loginWithEmployee(rcellItem)}
              >
                <LockIcon />
              </IconButton>
            ) : null}
            <IconButton
              aria-label="Edit"
              color="primary"
              size="small"
              onClick={() => redirectToCreateEmp(rcellItem?.id)}
            >
              <EditIcon />
            </IconButton>
          </>
        );

      default:
        return rcellItem[hcellItem?.id];
    }
  };

  const handelOnConfirm = () => {
    setIsLoading(true);
    updateEmployee(
      data?.rowitem?.id,
      { status: data?.newstatus },
      (res) => {
        if (res?.status === true) {
          setDialogOpen(false);
          setDialogOpenAppts(false);
          setIsLoading(false);
          setData({});
          fetchEmployeesList();
        } else {
          setIsLoading(false);
          setDialogOpen(false);
          setDialogOpenAppts(false);
          setData({});
        }
      },
      (resError) => {
        setIsLoading(false);
        setDialogOpen(false);
        setDialogOpenAppts(false);
        setData({});
        fetchEmployeesList();
      }
    );
  };

  const handelCloseDialog = () => {
    setDialogOpen(false);
    setData({});
    fetchEmployeesList();
  };
  const handelCloseApptDialog = () => {
    setDialogOpenAppts(false);
    setData({});
    fetchEmployeesList();
  };

  const handleCloseUsersDialog = () => {
    setUserDialog(false);
  };

  const OnSwitchChange = (rowitem, newstatus) => {
    const userLimit =
    pkgId === "prod_RvDCcqf57eCBxS" ? auth?.userProfile?.quantity : UsersLimits;
    const exceedsUserLimit = activeUsers >= userLimit;
    if(exceedsUserLimit){
      setUserDialog(true);
    } else {
      const filteredAppointments = appointments?.filter((appointment) => {
        const appointmentDateFormatted = dayjs(
          appointment.apoointmentDetails.date,
          "MMMM D, YYYY"
        ).startOf("day");
        return (
          appointmentDateFormatted.isSame(today, "day") ||
          appointmentDateFormatted.isAfter(today, "day")
        );
      });
      const data = filteredAppointments?.filter(
        (item) => item.userId === rowitem?.id
      );
      if (data && data.length > 0) {
        setDialogOpen(true);
        setData({
          rowitem: rowitem,
          newstatus: newstatus,
        });
      } else {
        setDialogOpenAppts(true);
        setData({
          rowitem: rowitem,
          newstatus: newstatus,
        });
      }
    }
  };
  const checkRowSearch = (searchTerm, row) => {
    return (
      String(row.acuityId)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.email)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.userName)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.phoneNumber)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.employeerole)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase())
    );
  };

  const filteredList = allEmployees?.filter((item) => {
    if (item?.deleted === true) return false;
    const matchesSearch =
      searchTerm !== "" ? checkRowSearch(searchTerm, item) : true;

    const matchesStatus =
      newStatus === "All" || newStatus === ""
        ? true
        : newStatus === true
        ? item?.status === true
        : item?.status === false ||
          item?.status === undefined ||
          item?.status === null;

    const matchesRole =
      newRoles === "All" || newRoles === ""
        ? true
        : item?.employeerole === newRoles;

    return matchesSearch && matchesStatus && matchesRole;
  });

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Employee"
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Employees" },
          ]}
          BreadCrumbCurrentPageTitle={"Manage"}
          showLastSeen={true}
          buttonTitle="Add Employees"
          icons={<Plus className="h-4 w-4 mr-5" />}
          buttonClass={"d-flex flex-center"}
          buttonStyle={{
            color: "white",
            backgroundColor: "#16A34A",
            padding: "8px 16px",
            borderRadius: "5px",
          }}
          buttonClick={() => navigate("/peoples/createEmp")}
          buttonTitle2="Manage Groups"
          buttonClick2={() => navigate("/peoples/manageGroups")}
        />
        <div className={isMobile ? "" : "p-24"}>
          <div style={{ margin: "0px auto" }}>
            <div
              className={
                isMobile
                  ? "d-flex flex-direction-column pv-15 ph-12"
                  : "d-flex flex-space-between flex-center mv-20"
              }
            >
              <div>
                <div
                className="text-foreground"
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                  }}
                >
                  Manage Employees
                </div>
                <div
                  className="mv-10"
                  style={{ fontSize: "16px", color: "#F1F5F9" }}
                >
                  View and manage your team members
                </div>
              </div>
            </div>
            <div
              className={isMobile ? "ph-10" : `sectionBox2 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
              style={{
                borderRadius: "8px",
                // border: "1px solid hsl(214.3, 31.8%, 91.4%)",
              }}
            >
              <div
                className={
                  isMobile
                    ? "d-flex flex-direction-column w-100"
                    : "d-flex flex-center flex-space-between"
                }
              >
                <div className={`${styles.searchFieldWrapper} mt-5`} style={{maxWidth: isMobile ? "" : "65%", marginBottom: isMobile ? "10px":""}}>
                  <div className="relative mb-4">
                    <Search
                      className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                      size={18}
                    />
                    <Input
                      placeholder="Search team members..."
                      className="pl-40 bg-white dark:bg-[#0F1729]"
                      value={searchTerm ? searchTerm : ""}
                      onChange={(event) => {
                        setsearchTerm(event.target.value);
                      }}
                    />
                  </div>
                </div>
                <div
                  className={
                    isMobile
                      ? "d-flex flex-direction-column"
                      : "d-flex flex-center"
                  }
                >
                  <div className={isMobile ? "" : "ml-15"} style={{ width: isMobile ? "400px" : "200px" }}>
                    <SingleSelectNew
                      id="roles"
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      placeholder="Roles"
                      options={Roles}
                      onChange={(value) => {
                        setNewRoles(value);
                      }}
                      value={newRoles ? newRoles : ""}
                    />
                  </div>
                  <div
                    className={isMobile ? "mv-15" : "mh-15"}
                    style={{ width: isMobile ? "400px" : "200px" }}
                  >
                    <SingleSelectNew
                      id="status"
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                      placeholder="Status"
                      options={StatusList}
                      onChange={(value) => {
                        setNewStatus(value);
                      }}
                      value={newStatus}
                    />
                  </div>
                </div>
              </div>

              {!isMobile && !isLandscape && (
                <ThemeTable
                  rows={filteredList}
                  headCells={Columns}
                  isLoading={isLoading}
                  hidePagination={true}
                  renderRowCell={renderRowCell}
                  OnSwitchChange={OnSwitchChange}
                />
              )}
              {(isMobile || isLandscape) && (
                <>
                  {filteredList?.map((record, index) => {
                    const handleSwitchChange = (event) => {
                      let newstatus = switchStatus;
                      setSwitchStatus(newstatus);
                      OnSwitchChange && OnSwitchChange(record, newstatus);
                    };
                    return (
                      <div className={`${styles.card} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
                        <div className="d-flex flex-center mb-14">
                          <div className={styles.clientInfo}>
                            {record?.avatar ? (
                              <div className={styles.avatarWrapper}>
                                <AspectRatio ratio={1 / 1}>
                                  <img
                                    src={record.avatar}
                                    alt={record.userName}
                                    className={styles.avatarImage}
                                  />
                                </AspectRatio>
                              </div>
                            ) : (
                              <div className={styles.avatarFallback}>
                                <span className={styles.avatarInitial}>
                                  {record?.userName.charAt(0)}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="ml-12">
                            <div
                              className="mb-8 dark:text-gray-100"
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                              }}
                            >
                              {record?.userName}
                            </div>
                            <div
                              className={
                                record?.employeerole === "Client Team"
                                  ? styles.client
                                  : record?.employeerole === "Admin"
                                  ? styles.admin
                                  : !record?.employeerole ? styles.unknown
                                  : styles.support
                              }
                            >
                              {record?.employeerole ? record?.employeerole : "Unknown"}
                            </div>
                          </div>
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          <div className={styles.infoRow}>
                            <span className={styles.label}>
                              <CallOutlinedIcon
                                fontSize="small"
                                className={`${styles.iconSmall} mr-4`}
                              />{" "}
                              <span className="font-mono dark:text-gray-400">
                                {record?.phoneNumber}
                              </span>
                            </span>
                          </div>
                          {record?.email && (
                            <div className={styles.infoRow2}>
                              <span className={styles.label}>
                                <MailOutlineIcon
                                  fontSize="small"
                                  className={`${styles.iconSmall} mr-4`}
                                />{" "}
                                <span className={styles.email}>
                                  <a
                                    href={`https://mail.google.com/mail/?view=cm&fs=1&to=${record?.email}`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    className="resLinks"
                                    style={{ overflowWrap: "anywhere" }}
                                  >
                                    {record?.email}
                                  </a>
                                </span>
                              </span>
                            </div>
                          )}
                          {/* <div className={styles.infoRow2}>
                            <span className={styles.label}>
                              <FontAwesomeIcon
                                icon={faBuilding}
                                className={`${styles.iconSmall} ml-3 mr-8`}
                              />{" "}
                              <span className="font-mono dark:text-gray-400">
                                {record?.company}
                              </span>
                            </span>
                          </div> */}
                        </div>

                        <div
                          className="d-flex flex-space-between flex-center mt-16 pv-10"
                        >
                          <div
                            className="d-flex flex-center"
                            style={{ gap: "8px" }}
                          >
                            <AntSwitch
                              checked={switchStatus}
                              onChange={handleSwitchChange}
                              color="primary"
                              name="switchStatus"
                              inputProps={{ "aria-label": "switchStatus" }}
                            />
                            <span
                              className={
                                `dark:text-gray-400 ${record?.status ? styles.active : styles.inactive}`
                              }
                            >
                              {record?.status ? "Active" : "Inactive"}
                            </span>
                          </div>
                          <div className={styles.buttonGroup}>
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() =>
                                navigate(`/peoples/createEmp/${record?.id}`)
                              }
                              className={styles.viewButton}
                            >
                              <VisibilityOutlinedIcon className="mr-5" />
                              View
                            </Button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
      {dialogOpen && (
        <ConfirmApptDiaogStatus
          open={dialogOpen}
          onConfirm={handelOnConfirm}
          onClose={handelCloseDialog}
          rowitem={data?.rowitem}
        />
      )}
      {dialogOpenAppts && (
        <ConfirmNotApptDiaogStatus
          open={dialogOpenAppts}
          onConfirm={handelOnConfirm}
          onClose={handelCloseApptDialog}
          rowitem={data?.rowitem}
        />
      )}
      {userDialog && (
        <userLimitAccess open={userDialog} onClose={handleCloseUsersDialog} />
      )}
    </>
  );
};
export default Employee;
